const validation = {
  emailOrUsername: {
    presence: {
      message: '^validation.restorePassword.enterEmailOrUserName'
    }
  },
};

export default validation;
